const EMode = {
  Venue: "VENUE",
  Event: "EVENT",
};

export default Object.freeze(EMode);
